<template>
    <v-layout>
        <v-snackbar
            :value="snackbar && !block_by_route"
            :right="true"
            :timeout="0"
            :top="true"
        >
            <v-layout row align-center
                      class="snackbar"
            >
                <v-flex v-if="$vuetify.breakpoint.mdAndUp" xs8 class="course-aside pa-3">
                    <div class="font-weight-bold">{{ $t("Итоговый тест курса") }}</div>
                    <div class="grey-text">{{ timer.course_name }}</div>
                </v-flex>
                <v-flex md4 sm12 align-center
                        :class="{'pa-2': $vuetify.breakpoint.smAndDown, 'pa-3': $vuetify.breakpoint.mdAndUp}"
                >
                    <div class="grey-text" :class="{'caption': $vuetify.breakpoint.smAndDown}">{{ $t("Осталось времени") }}</div>
                    <div class="red-text headline mt-1 mb-1" :class="{'title': $vuetify.breakpoint.smAndDown, 'headline': $vuetify.breakpoint.mdAndUp}"> {{ minutes }}:{{ seconds }} </div>
                    <linkGreen v-if="$vuetify.breakpoint.mdAndUp" @click.native="test_resume(timer.course_id)">{{ $t("Вернуться к тесту") }}</linkGreen>
                </v-flex>
            </v-layout>
        </v-snackbar>
    </v-layout>
</template>

<script>
import linkGreen from '@/components/ui/links/styled/link_green';
import {mapState, mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    linkGreen,
  },
  data() {
    return {
      seconds     : '00',
      minutes     : '00',
      blockedRoute: ['auth', 'course_content'],
    };
  },
  computed: {
    ...mapState('course_info', [
      'started_course_id',
      'interrupt_test',
      'started_course_name',
    ]),
    ...mapGetters('course_info', [
      'snackbar',
    ]),
    ...mapState('testing', [
      'timer',
    ]),
    block_by_route() {
      return this.blockedRoute.indexOf(this.$route.name) !== -1;
    },
  },
  watch: {
    $route() {
      if (
        this.snackbar &&
        this.interrupt_test ||
        !Object.keys(this.timer).length ||
        this.blockedRoute.indexOf(this.$route.name) !== -1 ||
        this.$route.name === 'course_content'
      ) {
        this.DISABLE_SNACKBAR();
      } else if (this.snackbar) {
        this.ENABLE_SNACKBAR();
      } else if (['course_content'].indexOf(this.$route.name) === -1) {
        this.test_hide();
      } else {
        this.DISABLE_SNACKBAR();
      }
    },
  },
  mounted() {
    this.parseTimer();
    this.updateTime();

    setInterval(() => {
      this.updateTime();
    }, 1000);
  },
  methods: {
    ...mapActions('testing', [
      'test_resume',
      'test_hide',
      'parseTimer',
      'killTimer',
    ]),
    ...mapMutations('course_info', [
      'DISABLE_SNACKBAR',
      'ENABLE_SNACKBAR',
    ]),
    updateTime() {
      if (Object.keys(this.timer).length) {
        if (new Date() > new Date(this.timer.time_end)) {
          this.killTimer();
        }

        let difference = new Date(new Date(this.timer.time_end) - new Date());
        this.minutes = String('0' + difference.getMinutes()).slice(-2);
        this.seconds = String('0' + difference.getSeconds()).slice(-2);
      }
    },
  },
};
</script>

<style lang="less">
.snackbar {
  width: 100%;
  font-size: 15px;
  background-color: #efefef;
}
</style>
